module.exports = __webpack_public_path__ + "fd1fe4f9a064457797c9cf8a20788a05.jpg";